import React from "react";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function ClearFilterButton({ onClick, variant }) {
  const { t } = useTranslation("common");

  return (
    <Button variant={variant} width={"full"} onClick={onClick}>
      {t("searchClearFilters")}
    </Button>
  );
}

export default ClearFilterButton;
